import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-newVipIcon6",
  "use": "icon-newVipIcon6-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-newVipIcon6\"><title>1.Base基础/3.Icon图标/其他/server</title><path fill-rule=\"evenodd\" d=\"M12.308 2.5v.865l-4.327.289-4.544-.29L3.654 10l-.217 6.558L10 16.346l6.42.212-.074-4.539.236-4.327h.918V17.5h-15v-15zm5.192 0-.577 4.038h-.577V4.572l-5.84 5.488-.409-.408 5.634-5.999h-2.27v-.576z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol